(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["common-collection-sizing-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const inBtn = document.querySelector('.unit-toggle__btn[data-unit="in"]');
  const cmBtn = document.querySelector('.unit-toggle__btn[data-unit="cm"]');
  const tables = document.querySelectorAll('.sizing-table');

  if (!tables.length || !inBtn || !cmBtn) return;

  const tableMap = [];

  tables.forEach(table => {
    const unitCells = [];

    table.querySelectorAll('tbody tr').forEach(row => {
      const cells = Array.from(row.querySelectorAll('td'));

      // Skip the first column ("Size"), store the rest
      cells.slice(1).forEach(cell => {
        const label = cell.querySelector('span')?.textContent.trim();
        const value = cell.textContent.trim().replace(label, '');
        const inch = parseFloat(value);

        if (!isNaN(inch)) {
          unitCells.push({ cell, label, inch });
        }
      });
    });

    tableMap.push({ table, unitCells });
  });

  function updateToCm() {
    tableMap.forEach(({ unitCells }) => {
      unitCells.forEach(({ cell, label, inch }) => {
        const cm = (inch * 2.54).toFixed(1);
        cell.innerHTML = `<span style="display:block">${label}</span>${cm}`;
      });
    });
    toggleActive('cm');
  }

  function updateToIn() {
    tableMap.forEach(({ unitCells }) => {
      unitCells.forEach(({ cell, label, inch }) => {
        cell.innerHTML = `<span style="display:block">${label}</span>${inch}`;
      });
    });
    toggleActive('in');
  }

  function toggleActive(unit) {
    inBtn.classList.toggle('is-active', unit === 'in');
    cmBtn.classList.toggle('is-active', unit === 'cm');
  }

  // Default to inches
  updateToIn();

  inBtn.addEventListener('click', updateToIn);
  cmBtn.addEventListener('click', updateToCm);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-feature-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  // Get the play button
  const playButton = document.getElementById("play-button");
  
  // Get the video element
  const video = document.querySelector(".feature-video__container video");

  // Check if video and play button exist
  if (playButton && video) {
    // Show the play button initially
    playButton.style.display = "flex";

    // Play the video when the play button is clicked
    playButton.addEventListener("click", function () {
      video.play(); // Play the video
      playButton.style.display = "none"; // Hide the play button when the video is playing
    });

    // Event listener for when the video ends, to reset the play button
    video.addEventListener("ended", function () {
      playButton.style.display = "flex"; // Show the play button again when the video ends
    });

    // Optional: You can add the 'pause' event handler to stop video when the user clicks to stop the video manually
    video.addEventListener("pause", function () {
      playButton.style.display = "flex"; // Show the play button again when the video is paused
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-featured"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // if the loader isn't there, bail
  if (typeof window.hhLoadSwiper !== 'function') return;

  window.hhLoadSwiper().then(function (Swiper) {
    // find every featured block on the page
    var sections = document.querySelectorAll('[data-hh-swiper-featured]');
    if (!sections.length) return;

    sections.forEach(function (root) {
      var carousel = root.querySelector('.new-carousel');
      if (!carousel) return;

      // prevent double init if section re-renders
      if (carousel.__hh_swiper_init__) return;
      carousel.__hh_swiper_init__ = true;

      new Swiper(carousel, {
        slidesPerView: 1.25,
        loop: false,
        spaceBetween: 20,
        centeredSlides: true,
        navigation: {
          nextEl: root.querySelector('.swiper-button-next'),
          prevEl: root.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: root.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 20,
            centeredSlides: true,
            loop: false,
          },
          511: {
            slidesPerView: 3,
            spaceBetween: 30,
            centeredSlides: false,
            loop: false,
          },
        },
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-split-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  function initSplitCarousels() {
    const sections = document.querySelectorAll('.split-carousel');
    if (!sections.length) return;

    sections.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const prevButton = section.querySelector('.swiper-button-prev');
      const nextButton = section.querySelector('.swiper-button-next');
      const pagination = section.querySelector('.swiper-pagination');
      const subheading = section.querySelector('#carousel-subheading strong');
      const content = section.querySelector('#carousel-content');
      const button = section.querySelector('#carousel-btn');

      if (!carousel || !prevButton || !nextButton || !pagination) {
        console.warn('Split carousel missing required elements:', section);
        return;
      }

      const swiper = new Swiper(carousel, {
        slidesPerView: 1.25,
        loop: false,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
        pagination: {
          el: pagination,
          type: 'fraction',
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
          slideToClickedSlide: false,
        },
        breakpoints: {
          519: { spaceBetween: 30 },
          768: { spaceBetween: 40 },
          1024: { spaceBetween: 60 },
        },
      });

      // when the slide changes, update the text / button on the left
      swiper.on('slideChange', () => {
        const activeSlide = swiper.slides[swiper.activeIndex];

        const subheadingText = activeSlide.getAttribute('data-subheading');
        const contentText = activeSlide.getAttribute('data-content');
        const buttonLink = activeSlide.getAttribute('data-button-link');
        const buttonLabel = activeSlide.getAttribute('data-button-label');

        if (subheading) subheading.innerText = subheadingText || '';
        if (content) content.innerHTML = contentText || '';

        if (button) {
          if (buttonLink && buttonLabel) {
            button.href = buttonLink;
            button.innerText = buttonLabel;
            button.style.display = 'inline-block';
          } else {
            button.style.display = 'none';
          }
        }
      });

      // initial content from first slide
      const initialSlide = swiper.slides[swiper.activeIndex];
      if (subheading) subheading.innerText = initialSlide.getAttribute('data-subheading') || '';
      if (content) content.innerHTML = initialSlide.getAttribute('data-content') || '';

      const initialButtonLink = initialSlide.getAttribute('data-button-link');
      const initialButtonLabel = initialSlide.getAttribute('data-button-label');
      if (button) {
        if (initialButtonLink && initialButtonLabel) {
          button.href = initialButtonLink;
          button.innerText = initialButtonLabel;
          button.style.display = 'inline-block';
        } else {
          button.style.display = 'none';
        }
      }
    });
  }

  // use the shared loader if it exists
  var loaderPromise;

  if (typeof window.hhLoadSwiper === 'function') {
    loaderPromise = window.hhLoadSwiper();
  } else if (typeof window.Swiper !== 'undefined') {
    // swiper already on page (some other script included it)
    loaderPromise = Promise.resolve(window.Swiper);
  } else {
    // nothing to load it — fail silently so the page still renders
    loaderPromise = Promise.reject('Swiper not available');
  }

  loaderPromise
    .then(function () {
      initSplitCarousels();
    })
    .catch(function (err) {
      // optional: console.warn(err);
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    var wrap=document.querySelector('.carousel-wrapper');
    if(!wrap) return;

    // Drop reservation as soon as Swiper initialises; fall back to window load
    var done=function(){wrap.classList.add('is-ready')};
    if(document.querySelector('.swiper-container.swiper-initialized')) done();
    else{
      var obs=new MutationObserver(function(muts){
        if(document.querySelector('.swiper-container.swiper-initialized')){done();obs.disconnect();}
      });
      obs.observe(document.body,{subtree:true,attributes:true,attributeFilter:['class']});
      window.addEventListener('load',done,{once:true});
    }
  });

  } catch(e) { console.error(e); }
})();
})();
